import { common } from '@material-ui/core/colors';

const background = {
    'default': common.white,
    paper: common.white,
};
export default background;
